import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { ComponentTitle, ComponentBodyDecrement } from "./Common";
import { AddCommaNumber } from "../../../helpers/Utils";
import { Row } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";

// Status badge component
const StockStatusBadge = ({ status, daysRemaining }) => {
  const statusConfig = {
    critical: {
      label: <IntlMessages id="analytics.table.stock_status.critical" />,
      bg: "#dc3545",
      icon: "🔴",
    },
    warning: {
      label: <IntlMessages id="analytics.table.stock_status.warning" />,
      bg: "#ffc107",
      color: "#000",
      icon: "🟡",
    },
    normal: {
      label: <IntlMessages id="analytics.table.stock_status.normal" />,
      bg: "#28a745",
      icon: "🟢",
    },
  };

  const config = statusConfig[status] || statusConfig.normal;

  return (
    <span
      className="badge"
      style={{
        backgroundColor: config.bg,
        color: config.color || "#fff",
        fontSize: "11px",
      }}
    >
      {config.icon} {daysRemaining} ngày
    </span>
  );
};

export default (props) => {
  const [state, setState] = useState({
    columns: [],
  });

  const { summary } = props;

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: <div style={{ textAlign: "center" }}>{props.title}</div>,
          columns: [
            {
              Header: <IntlMessages id="analytics.table.stt" />,
              accessor: "stt",
              maxWidth: 40,
            },
            {
              Header: <IntlMessages id="analytics.table.material" />,
              accessor: "label",
              minWidth: 120,
            },
            {
              Header: <IntlMessages id="analytics.table.stock" />,
              accessor: "current_stock",
              maxWidth: 80,
              Cell: (_props) => (
                <div className="text-center font-weight-bold">
                  {_props.value || 0} {_props.original.unit}
                </div>
              ),
            },
            {
              Header: (
                <div style={{ textAlign: "center" }}>
                  <IntlMessages id="analytics.table.total_import" />
                </div>
              ),
              accessor: "stock_total",
              maxWidth: 80,
              Cell: (_props) => {
                const value = _props.value + " " + _props.original.unit;
                return (
                  <div className="text-center font-weight-bold">{value}</div>
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.value" />}
                  value={AddCommaNumber(props.total_price)}
                  align="end"
                />
              ),
              minWidth: 100,
              accessor: "price",
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => {
                return (
                  <ComponentBodyDecrement
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="price"
                    align="end"
                    value={_props.value}
                    compare_value={_props.original.compare_price}
                  />
                );
              },
            },
          ],
        },
      ],
    });
  }, [props.data, props.setting.compare, props.setting.all]);

  return (
    <div>
      <ReactTable
        defaultPageSize={6}
        data={props.data}
        columns={state.columns}
        minRows={0}
        showPageJump={false}
        showPageSizeOptions={true}
        PaginationComponent={Pagination}
        NoDataComponent={() => null}
        getTrProps={(state, rowInfo) => {
          if (
            rowInfo &&
            rowInfo.original &&
            rowInfo.original.stock_status === "critical"
          ) {
            return {
              style: { backgroundColor: "rgba(220, 53, 69, 0.1)" },
            };
          }
          if (
            rowInfo &&
            rowInfo.original &&
            rowInfo.original.stock_status === "warning"
          ) {
            return {
              style: { backgroundColor: "rgba(255, 193, 7, 0.1)" },
            };
          }
          return {};
        }}
      />
    </div>
  );
};
